import { useMemo } from 'react';

import { Dictionary, getDictionary } from '../../config/locale/locale';
import type { LanguageType } from '../../constants/enums';
import { useAppSelector } from '../../store/hooks';

export interface UseTranslationResult {
  /** The active dictionary. Access copy by property, e.g. `t.nav.vrMods`. */
  t: Dictionary;
  language: LanguageType;
}

/**
 * Resolves the dictionary for the language currently held in Redux
 * (`state.locale.language`). `t` is the dictionary object itself, so every
 * lookup is checked by the compiler.
 */
export const useTranslation = (): UseTranslationResult => {
  const language = useAppSelector((state) => state.locale.language);
  const t = useMemo(() => getDictionary(language), [language]);

  return { t, language };
};
